import { useEffect, useState } from "react";
import { MdOutlinePayment } from "react-icons/md";
import { MdOutlineLockPerson } from "react-icons/md";
import { TbCube } from "react-icons/tb";
import BillingHistory from "./BillingHistory";
import ManagePlan from "./ManagePlan";
import ChangePassword from "./ChangePassword";
import axiosClient from "../../axios-client";

const AccountSettings = () => {
  const [activeTab, setActiveTab] = useState("changePassword");
  const userID = localStorage.getItem("userID");
  const token = localStorage.getItem("token");
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    if (token) {
      const fetchSubscriptions = async () => {
        try {
          const response = await axiosClient.get(
            `/subscriptions/getSubscriptionsByUser/${userID}`
          );

          setSubscriptions(response.data);
          console.log("Subscriptions:", response.data);
          const reportDownload = response.data[0].plan.features.reportDownloads;
          if (
            response.data.length > 0 &&
            response.data[0].status === "Active"
          ) {
            localStorage.setItem("userStatus", "Active");
            localStorage.setItem("User Plan", response.data[0].plan.name);
            localStorage.setItem("downloadReport", reportDownload);
          }
        } catch (error) {
          console.error("Error fetching subscriptions:", error);
        }
      };
      fetchSubscriptions();
    }
  }, [token, userID]);

  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-4 pb-16 sm:pb-24 min-h-screen font-inter">
      <h2 className="font-inter text-2xl sm:text-3xl lg:text-4xl font-semibold font4 mb-4">
        Account Setting
      </h2>

      <div className="flex flex-col sm:flex-row justify-between items-center border-b-2 bg-gray-300 p-2 sm:p-4 w-full sm:w-[85%] lg:w-[50%] rounded-2xl">
        <button
          className={`flex items-center space-x-2 p-2 w-full sm:w-auto mb-2 sm:mb-0 justify-center ${
            activeTab === "changePassword"
              ? "text-black font-medium bg-white p-3 rounded-xl"
              : "text-gray-400"
          }`}
          onClick={() => setActiveTab("changePassword")}
        >
          <MdOutlineLockPerson className="text-xl" />
          <span className="whitespace-nowrap">Change Password</span>
        </button>

        <button
          className={`flex items-center space-x-2 p-2 w-full sm:w-auto mb-2 sm:mb-0 justify-center ${
            activeTab === "billingHistory"
              ? "text-black font-medium bg-white p-3 rounded-xl"
              : "text-gray-400"
          }`}
          onClick={() => setActiveTab("billingHistory")}
        >
          <MdOutlinePayment className="text-xl" />
          <span className="whitespace-nowrap">Billing History</span>
        </button>

        <button
          className={`flex items-center space-x-2 p-2 w-full sm:w-auto justify-center ${
            activeTab === "managePlan"
              ? "text-black font-medium bg-white p-3 rounded-xl"
              : "text-gray-400"
          }`}
          onClick={() => setActiveTab("managePlan")}
        >
          <TbCube className="text-xl" />
          <span className="whitespace-nowrap">Manage Plan</span>
        </button>
      </div>

      <div className="mt-6">
        {activeTab === "changePassword" && <ChangePassword />}

        {activeTab === "billingHistory" && <BillingHistory />}

        {activeTab === "managePlan" && <ManagePlan />}
      </div>
    </div>
  );
};

export default AccountSettings;
